module.exports = __webpack_public_path__ + "static/media/event-services-img22.4195e262.jpg";